var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8594 0H9.14062C5.65125 0 2.8125 2.83875 2.8125 6.32812V48L19.0781 39.8672L35.3438 48V25.4062H45.1875V6.32812C45.1875 2.83875 42.3488 0 38.8594 0ZM32.5312 6.32812V43.4493L19.0781 36.7227L5.625 43.4493V6.32812C5.625 4.38956 7.20206 2.8125 9.14062 2.8125H33.6C32.9253 3.81862 32.5312 5.02838 32.5312 6.32812ZM42.375 22.5938H35.3438V6.32812C35.3438 4.38956 36.9208 2.8125 38.8594 2.8125C40.7979 2.8125 42.375 4.38956 42.375 6.32812V22.5938Z",
    fill: "#B4C1E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2002 18C15.8918 18 13.2002 20.6916 13.2002 24C13.2002 27.3084 15.8918 30 19.2002 30C22.5086 30 25.2002 27.3084 25.2002 24C25.2002 20.6916 22.5086 18 19.2002 18ZM19.2002 28.5678C16.6815 28.5678 14.6324 26.5187 14.6324 24C14.6324 21.4813 16.6815 19.4322 19.2002 19.4322C21.7189 19.4322 23.768 21.4813 23.768 24C23.768 26.5187 21.7189 28.5678 19.2002 28.5678Z",
    fill: "#B4C1E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3364 23.2814H19.9167V21.8616C19.9167 21.4661 19.596 21.1455 19.2006 21.1455C18.8051 21.1455 18.4845 21.4661 18.4845 21.8616V23.2814H17.0647C16.6693 23.2814 16.3486 23.602 16.3486 23.9975C16.3486 24.393 16.6693 24.7136 17.0647 24.7136H18.4845V26.1333C18.4845 26.5288 18.8051 26.8494 19.2006 26.8494C19.596 26.8494 19.9167 26.5288 19.9167 26.1333V24.7136H21.3364C21.7319 24.7136 22.0525 24.393 22.0525 23.9975C22.0525 23.602 21.7319 23.2814 21.3364 23.2814Z",
    fill: "#B4C1E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.55f1972ac04f52e82bea62cf72be33af.svg";
export { ForwardRef as ReactComponent };